import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { SupplierDashboard } from "../../../api";

export const supplierDashboardKeys = {
  emissionsReports: () => ["emissionsReports"],
  topTenSuppliersReports: () => ["topTenSuppliersReports"],
  supplierSpecificReport: () => ["supplierSpecificReport"],
  userSpecificSupplier: () => ["userSpecificSupplier"],
  supplierTiersEmissions: () => ["supplierTiersEmissions"],
  specificSupplierEmissions: () => ["specificSupplierEmissions"],
  suppliersYearByYearData: () => ["suppliersYearByYearData"],
  suppliersYearByYearAverageData: () => ["suppliersYearByYearAverageData"],
};

export function useGetSuppliersEmissionsReports(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierDashboardKeys.emissionsReports(), params],
    () => callApi(SupplierDashboard.getSuppliersEmissionsReports, params),
    config
  );
}

export function useGetTopTenSuppliersReports(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierDashboardKeys.topTenSuppliersReports(), params.year],
    () => callApi(SupplierDashboard.getTopTenSuppliersReports, { params }),
    config
  );
}

export function useGetSupplierSpecificReport(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierDashboardKeys.supplierSpecificReport(), params.year, params.quarter],
    () => callApi(SupplierDashboard.getSupplierSpecificReport, { params }),
    config
  );
}

export function useGetUserSpecificSupplier(config) {
  const { callApi } = useAuth();
  return useQuery(
    supplierDashboardKeys.userSpecificSupplier(),
    () => callApi(SupplierDashboard.getUserSpecificSupplier),
    config
  );
}

export function useGetSupplierTiersEmissions(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierDashboardKeys.supplierTiersEmissions(), params.year],
    () => callApi(SupplierDashboard.getSupplierTiersEmissions, { params }),
    config
  );
}

export function useGetSpecificSupplierEmissions(supplierId, year, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierDashboardKeys.specificSupplierEmissions(), supplierId, year],
    () => callApi(SupplierDashboard.getSpecificSupplierEmissions, { supplierId, year }),
    config
  );
}

/**
 * @Deprecated Use useGetSuppliersYealyData instead
 * @param params
 * @param config
 * @returns {UseQueryResult<*, unknown>}
 */
export function useGetSuppliersYearByYearData(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierDashboardKeys.suppliersYearByYearData(), params],
    () => callApi(SupplierDashboard.getSuppliersYearByYearData, params),
    config
  );
}

export function useGetSuppliersYearlyData(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierDashboardKeys.suppliersYearByYearData(), params],
    () => callApi(SupplierDashboard.getSupplierYearlyData, params),
    config
  );
}

export function useChangeReportExclusion(config) {
  const { callApi } = useAuth();
  return useMutation((data) => callApi(SupplierDashboard.updateReportExclusion, data), config);
}

export function useGetSuppliersYearByYearAverageData(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierDashboardKeys.suppliersYearByYearAverageData(), params],
    () => callApi(SupplierDashboard.getSuppliersYearByYearAverageData, params),
    config
  );
}

export function useExportTotalEmissions(config) {
  const { callApi } = useAuth();
  return useMutation((params) => callApi(SupplierDashboard.exportTotalEmissions, params), config);
}

export function useExportYearByYearData(config) {
  const { callApi } = useAuth();
  return useMutation(() => callApi(SupplierDashboard.exportYearByYearData), config);
}
